import routes from "./routes";
import Vue from 'vue';

import Vuex from 'vuex';
import Router from 'vue-router';
import { sync } from 'vuex-router-sync';

import App from './components/App.vue';

require("iframe-resizer/js/iframeResizer.contentWindow");

import storeConfig from "./store";
import vueI18n from "./i18n.js";
import vuetify from './vuetify'
import icons from "./icons";

//import "./scss/main.scss";

function createRouter(routes) {
  let urlParts = process.env.BASE_URL.split("/").filter(p => p != "");
  urlParts.pop();

  const router = new Router({
    base: "/" + urlParts.join("/"),
    routes,
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }

      return { x: 0, y: 0 };
    },
  });

  return router;
}

Vue.config.productionTip = false;

Vue.use(Router);
Vue.use(Vuex);
Vue.use(vueI18n.VueI18n);
Vue.use(icons);

// theme injected inline css und das wird von der CSP geblockt
// https://github.com/vuetifyjs/vuetify/issues/3349

const router = createRouter(routes);

const store = new Vuex.Store(storeConfig);

sync(store, router);

const vue = new Vue({
  store,
  router,
  i18n: new vueI18n.VueI18n(vueI18n.options),
  vuetify,
  render: h => h(App)
}).$mount('#app');

if (navigator.oscpu && navigator.oscpu.indexOf("NT 6") != -1) {
    document.querySelector("body").classList.add("legacy");
}

if (navigator.userAgent && navigator.userAgent.indexOf("MSIE") != -1
    || (!!window.MSInputMethodContext && !!document.documentMode)) {
    document.querySelector("body").classList.add("not-supported");
}